import { Directive, forwardRef } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';

@Directive({
    selector: '[validateEmail][formControlName],[validateEmail][formControl],[validateEmail][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => EmailValidatorDirective),
            multi: true,
        },
    ],
})
export class EmailValidatorDirective implements Validator
{
    public validate(control: AbstractControl): { [key: string]: any } {
        if (!control || !control.value) {
            return null;
        }

        const regex = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

        if (!regex.test(control.value)) {
            return {emailInvalid: true};
        }

        return null;
    }
}
